import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-5 py-12 text-white" data-id="element-113" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-5xl text-center" data-id="element-114" data-mp="3ghc5e9zhvhrx">
        <p className="font-display text-2xl font-extrabold uppercase tracking-tight" data-id="element-115" data-mp="32ovw4rg02nik">
          Mathe <span className="text-sun" data-id="element-116" data-mp="36oo9rik93jus">Bereit™</span>
        </p>
        <nav aria-label="Footer" data-id="element-117" data-mp="36n3bbhutfgrn">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm font-medium text-white/70" data-id="element-118" data-mp="3uesa9h2573hk">
            {footerLinks.map(link => <li key={link} data-id="element-119" data-mp="3lecbgkwcgkj1">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-sun" data-id="element-120" data-mp="3lf56iolxxllc">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-8 text-xs text-white/50" data-id="element-121" data-mp="29y5i442prqwl">
          © 2026 MATHE BEREIT™. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}